import Assignees, { Props } from './Assignees';

export default Assignees;
export { type Props };
